var map = {
	"./de.png": "72fe",
	"./en.png": "9996",
	"./es.png": "20ca",
	"./fr.png": "26fc",
	"./it.png": "7ba1",
	"./nl.png": "3fed",
	"./pt.png": "5e3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";